import FloatingFieldExamplePage from "./FloatingFieldExamplePage";

export default function FloatingFieldMdPage() {
  return <FloatingFieldExamplePage size="md" />;
}
